







import _ from 'lodash';
import { ComponentInternalInstance, defineComponent, getCurrentInstance, nextTick, ref } from '@vue/composition-api';
import i18n, { LanguageOptions } from '@/locales/i18n';
import { setLanguage } from '@/locales/languageSettingMethod';

export default defineComponent({
  name: 'LanguageSetting',
  setup() {
    // 当前组件
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const currentLanguage = ref(i18n.locale);
    const languageOptions = ref(LanguageOptions);
    const onChange = (checkedValues: string) => {
      setLanguage(checkedValues);
      nextTick(() => {
        currentLanguage.value = i18n.locale;
      });
    };

    return {
      onChange,
      currentLanguage,
      languageOptions,
    };
  },
});
